var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenRecordPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.896,
    height: 20.5,
    viewBox: "0 0 14.353 14.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .plus{fill:#6d6d70}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-zoomIn",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4086",
    d: "M992.319 1084.661h-2.233v-2.233a.283.283 0 0 0-.566 0v2.233h-2.233a.283.283 0 0 0 0 .566h2.233v2.233a.283.283 0 0 0 .566 0v-2.233h2.233a.283.283 0 0 0 0-.566z",
    className: "plus",
    transform: "translate(-983.86 -1079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4087",
    d: "M990.164 1084.632l-3.806-3.806a5.96 5.96 0 1 0-.387.413l3.793 3.793a.283.283 0 1 0 .4-.4zm-8.327-2.277a5.377 5.377 0 1 1 5.377-5.377 5.384 5.384 0 0 1-5.377 5.377z",
    className: "plus",
    transform: "translate(-975.894 -1071.034)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenRecordPlus);
export default __webpack_public_path__ + "static/media/PenRecordPlus.8ea1644b.svg";
export { ForwardRef as ReactComponent };